function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M512,0h-63.541L422,13.229L395.541,0H266.459l-30,15h-82.918l-30-15H0v245.541l15,30v82.918l-15,30V512h258.541 L285,498.771L311.459,512H512V313.459L498.771,287L512,260.541V0z M482,253.459L465.229,287L482,320.541V482H318.541L285,465.229 L251.459,482H30v-86.459l15-30v-97.082l-15-30V30h86.459l30,15h97.082l30-15h114.918L422,46.771L455.541,30H482V253.459z"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M383.213,75H250.787L437,261.213V128.787L383.213,75z M407,188.787L323.213,105h47.573L407,141.213V188.787z"
})));
var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M75,250.787v132.426L128.787,437h132.427L75,250.787z M105,370.787v-47.574L188.787,407h-47.573L105,370.787z"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M118.603,70.185l-48.997,48.996l190.495,223.85l27.223,11.576l7.073,28.724L340.069,437h79.94l18.095-126.66 L118.603,70.185z M393.991,407h-40.06l-32.098-37.719l-8.965-36.413l-34.51-14.674L110.394,120.819l11.004-11.004L405.896,323.66 L393.991,407z"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", null);
var _ref7 = /*#__PURE__*/React.createElement("g", null);
var _ref8 = /*#__PURE__*/React.createElement("g", null);
var _ref9 = /*#__PURE__*/React.createElement("g", null);
var _ref0 = /*#__PURE__*/React.createElement("g", null);
var _ref1 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
var _ref16 = /*#__PURE__*/React.createElement("g", null);
var _ref17 = /*#__PURE__*/React.createElement("g", null);
var _ref18 = /*#__PURE__*/React.createElement("g", null);
function SvgDota2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDota2);
export default __webpack_public_path__ + "static/media/dota-2.cd704ba8.svg";
export { ForwardRef as ReactComponent };